// extracted by mini-css-extract-plugin
var _1 = "SimpleCell_hoverAction__wXcXN";
var _2 = "SimpleCell_rightAction__X6Vr+";
export { _1 as "hoverAction", _2 as "rightAction" }
